export enum AppResourceTypes {
    roles = "roles",
    prices = "prices",
    qr_logos = "qr_logos",
    countries = "countries",
    currencies = "currencies",
    organizations = "organizations",
}
